import { auth } from '../../utils/firebase';

export default function logout() {
  auth.signOut();
}
